import { render, staticRenderFns } from "./OverviewLegacy.vue?vue&type=template&id=c126e468&"
import script from "./OverviewLegacy.vue?vue&type=script&lang=js&"
export * from "./OverviewLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports